










import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {DataType, Field} from '@/components/DataGrid.vue'
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {defineComponent} from "@vue/composition-api"
import DataGridWidget from "@/components/widgets/DataGridWidget.vue"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Table(),
    widget: "AuditConsistentlyFailingElements",
    title: "Consistently Failing Elements",
    params: {
      auditCategory: {...WParamTpl.auditCategory(), _order: 1},
    },
  }
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    DataGridWidget,
  },
  setup(props, context) {
    context.emit("config-update", config())
    const fields: Field[] = [
      {name: 'name', title: 'Name', dataType: DataType.Text, sort: true},
      {name: 'PercentPass', title: 'Pass %', dataType: DataType.Number, sort: true},
      {name: 'PercentFail', title: 'Fail %', dataType: DataType.Number, sort: true},
    ]

    async function dataFetcher(offset: number, max: number) {
      if (offset !== 0) {
        return []
      }
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
      const toDate = getTodayYYYYMMDD()
      const categoryID = props.config && props.config.params.auditCategory.value.value || 0
      return await executeQuery(
        "micad4-audit",
        "consistentlyFailingElements",
        {locale: "en-GB", fromDate, toDate, categoryID},
        dataFilter)
    }

    function titleCallback(config: any) {
      return "Category: " + (config.params.auditCategory.value.title || "<All>")
    }

    return {fields, dataFetcher, titleCallback}
  },
})

function dataFilter(data: Array<{ elementTypeID: bigint, name: string, PercentPass: number, PercentFail: number }>): any {
  const filteredData: any[] = []
  for (const item of data) {
    filteredData.push({
      ...item,
      PercentPass: Math.round(item.PercentPass * 10) / 10,
      PercentFail: Math.round(item.PercentFail * 10) / 10,
    })
  }
  return filteredData
}
